import { render, staticRenderFns } from "./TeamTask.vue?vue&type=template&id=50a82a42&scoped=true&"
import script from "./TeamTask.vue?vue&type=script&lang=js&"
export * from "./TeamTask.vue?vue&type=script&lang=js&"
import style0 from "./TeamTask.vue?vue&type=style&index=0&id=50a82a42&lang=scss&scoped=true&"
import style1 from "./TeamTask.vue?vue&type=style&index=1&id=50a82a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a82a42",
  null
  
)

export default component.exports